<template>
  <div class="wrapper">
    <Sidebar :close="close"  />

    <div id="page-content-wrapper">
      <NavHeader :status="close" @update:status="close = $event" />

      <!-- Page content-->
      <div id="vista" class="container-fluid" :class="{'active': close }">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./partials/Sidebar";
import NavHeader from "./partials/NavHeader";

export default {
  name: "Layout",
  
  components: { Sidebar, NavHeader },
  
  data() {
    return {
      close: false,
    };
  },

  mounted() {
    let widthNav = window.innerWidth;
    if(widthNav < 630) this.close = true;
  },
};
</script>

<style lang="scss">
.wrapper {
  display: flex;
  overflow-x: hidden;
  min-height: 100vh;
  background-color: #eaedf7;

  #page-content-wrapper{
    min-width: 0;
    width: 100%;

    .active{
      opacity: 1;
    }
  }

  @media screen and (max-width: 630px) {
    #vista{
      opacity: 0;
      transition: all 0.3s ease-in-out;
    }
  }
}
</style>
